import { $http } from "./http";
import { getBrandWCPayRequest } from "@/utils/wxpay";
import router from "@/router/index";
import Vue from "vue";
import store from "@/store";
import { Toast } from "vant";
Vue.use(Toast);
import { sqbWxPay, sqbH5Pay } from "@/api/pay";
import { getUserCardInfo, checkIsNeedRegisterWechatMember } from "@/api/member";
import { handleLocalStorage } from "@/utils";
import { setToken } from "@/utils/auth";
import wxConfig from "./wxConfig";

export function deepClone(source) {
  if (!source && typeof source !== "object") {
    throw new Error("error arguments", "deepClone");
  }
  const targetObj = source.constructor === Array ? [] : {};
  Object.keys(source).forEach((keys) => {
    if (source[keys] && typeof source[keys] === "object") {
      targetObj[keys] = deepClone(source[keys]);
    } else {
      targetObj[keys] = source[keys];
    }
  });
  return targetObj;
}

export function toTel(phone) {
  if (!phone) {
    return;
  }
  if (process.env.NODE_ENV === "development") {
    console.log("本地就别点了");
    return;
  }
  let to = `tel:${phone}`;
  window.location.href = to;
}

export function setS(str, params, isLocalStorage = false) {
  const handleParams = JSON.stringify(params);
  if (isLocalStorage) {
    localStorage.setItem(str, handleParams);
  } else {
    sessionStorage.setItem(str, handleParams);
  }
}

export function getS(data) {
  // 先获取localStorage数据, 如果没有再获取sessionStorage数据。 如果都没有， null;
  let getLocalData = localStorage.getItem(data);
  let getSessionData = sessionStorage.getItem(data);
  if (getLocalData) {
    try {
      getLocalData = JSON.parse(getLocalData);
    } catch (e) {
      // console.error(e);
    }
    return getLocalData;
  } else if (getSessionData) {
    try {
      getSessionData = JSON.parse(getSessionData);
    } catch (e) {
      // console.error(e);
    }
    return getSessionData;
  }
  return null;
}

export function clearS(str) {
  if (!str) {
    sessionStorage.clear();
    localStorage.clear();
    return;
  }
  sessionStorage.removeItem(str);
  localStorage.removeItem(str);
}

// 判断浏览器环境
export function getBrowserType() {
  const ua = navigator.userAgent.toLowerCase();
  const testUa = (regexp) => regexp.test(ua);
  const testVs = (regexp) =>
    ua
      .match(regexp)
      .toString()
      .replace(/[^0-9|_.]/g, "")
      .replace(/_/g, ".");
  // 获取对应字段信息
  // 系统
  let system = "unknow";
  if (testUa(/windows|win32|win64|wow32|wow64/g)) {
    system = "windows"; // windows系统
  } else if (testUa(/macintosh|macintel/g)) {
    system = "macos"; // macos系统
  } else if (testUa(/x11/g)) {
    system = "linux"; // linux系统
  } else if (testUa(/android|adr/g)) {
    system = "android"; // android系统
  } else if (testUa(/ios|iphone|ipad|ipod|iwatch/g)) {
    system = "ios"; // ios系统
  }

  // 系统版本
  let systemVs = "unknow";
  if (system === "windows") {
    if (testUa(/windows nt 5.0|windows 2000/g)) {
      systemVs = "2000";
    } else if (testUa(/windows nt 5.1|windows xp/g)) {
      systemVs = "xp";
    } else if (testUa(/windows nt 5.2|windows 2003/g)) {
      systemVs = "2003";
    } else if (testUa(/windows nt 6.0|windows vista/g)) {
      systemVs = "vista";
    } else if (testUa(/windows nt 6.1|windows 7/g)) {
      systemVs = "7";
    } else if (testUa(/windows nt 6.2|windows 8/g)) {
      systemVs = "8";
    } else if (testUa(/windows nt 6.3|windows 8.1/g)) {
      systemVs = "8.1";
    } else if (testUa(/windows nt 10.0|windows 10/g)) {
      systemVs = "10";
    }
  } else if (system === "macos") {
    systemVs = testVs(/os x [\d._]+/g);
  } else if (system === "android") {
    systemVs = testVs(/android [\d._]+/g);
  } else if (system === "ios") {
    systemVs = testVs(/os [\d._]+/g);
  }

  // 平台
  let platform = "unknow";
  if (system === "windows" || system === "macos" || system === "linux") {
    platform = "desktop"; // 桌面端
  } else if (system === "android" || system === "ios" || testUa(/mobile/g)) {
    platform = "mobile"; // 移动端
  }

  // 内核 + 载体
  let engine = "unknow";
  let supporter = "unknow";
  if (testUa(/applewebkit/g)) {
    engine = "webkit"; // webkit内核
    if (testUa(/edge/g)) {
      supporter = "edge"; // edge浏览器
    } else if (testUa(/opr/g)) {
      supporter = "opera"; // opera浏览器
    } else if (testUa(/chrome/g)) {
      supporter = "chrome"; // chrome浏览器
    } else if (testUa(/safari/g)) {
      supporter = "safari"; // safari浏览器
    }
  } else if (testUa(/gecko/g) && testUa(/firefox/g)) {
    engine = "gecko"; // gecko内核
    supporter = "firefox"; // firefox浏览器
  } else if (testUa(/presto/g)) {
    engine = "presto"; // presto内核
    supporter = "opera"; // opera浏览器
  } else if (testUa(/trident|compatible|msie/g)) {
    engine = "trident"; // trident内核
    supporter = "iexplore"; // iexplore浏览器
  }

  // 内核版本
  let engineVs = "unknow";
  if (engine === "webkit") {
    engineVs = testVs(/applewebkit\/[\d._]+/g);
  } else if (engine === "gecko") {
    engineVs = testVs(/gecko\/[\d._]+/g);
  } else if (engine === "presto") {
    engineVs = testVs(/presto\/[\d._]+/g);
  } else if (engine === "trident") {
    engineVs = testVs(/trident\/[\d._]+/g);
  }

  // 载体版本
  let supporterVs = "unknow";
  // if (supporter === "chrome") {
  //   supporterVs = testVs(/chrome\/[\d._]+/g);
  // } else if (supporter === "safari") {
  //   supporterVs = testVs(/version\/[\d._]+/g);
  // } else if (supporter === "firefox") {
  //   supporterVs = testVs(/firefox\/[\d._]+/g);
  // } else if (supporter === "opera") {
  //   supporterVs = testVs(/opr\/[\d._]+/g);
  // } else if (supporter === "iexplore") {
  //   supporterVs = testVs(/(msie [\d._]+)|(rv:[\d._]+)/g);
  // } else if (supporter === "edge") {
  //   supporterVs = testVs(/edge\/[\d._]+/g);
  // }

  // 外壳 + 外壳版本
  let shell = "none";
  let shellVs = "unknow";
  if (testUa(/micromessenger/g)) {
    shell = "wechat"; // 微信浏览器
    shellVs = testVs(/micromessenger\/[\d._]+/g);
  } else if (testUa(/qqbrowser/g)) {
    shell = "qq"; // QQ浏览器
    shellVs = testVs(/qqbrowser\/[\d._]+/g);
  } else if (testUa(/ucbrowser/g)) {
    shell = "uc"; // UC浏览器
    shellVs = testVs(/ucbrowser\/[\d._]+/g);
  } else if (testUa(/qihu 360se/g)) {
    shell = "360"; // 360浏览器(无版本)
  } else if (testUa(/2345explorer/g)) {
    shell = "2345"; // 2345浏览器
    shellVs = testVs(/2345explorer\/[\d._]+/g);
  } else if (testUa(/metasr/g)) {
    shell = "sougou"; // 搜狗浏览器(无版本)
  } else if (testUa(/lbbrowser/g)) {
    shell = "liebao"; // 猎豹浏览器(无版本)
  } else if (testUa(/maxthon/g)) {
    shell = "maxthon"; // 遨游浏览器
    shellVs = testVs(/maxthon\/[\d._]+/g);
  }

  // 获取到system、systemVs、platform、engine、engineVs、supporter、supporterVs、shell、shellVs
  return Object.assign(
    {
      engine, // webkit gecko presto trident
      engineVs,
      platform, // desktop mobile
      supporter, // chrome safari firefox opera iexplore edge
      supporterVs,
      system, // windows macos linux android ios
      systemVs,
    },
    shell === "none"
      ? {}
      : {
          shell, // wechat qq uc 360 2345 sougou liebao maxthon
          shellVs,
        }
  );
}

export function test(str) {
  console.log(
    "%c str ",
    "background-image:color:transparent;color:blue;font-size:2em"
  );
  console.log(str);
}

export function consultMap(_this, shopLat, shopLon, storeName, shopAddress) {
  wx.ready(() => {
    wx.checkJsApi({
      jsApiList: ["openLocation"],
      success: function (res) {
        if (res.checkResult.openLocation === false) {
          Toast("你的微信版本太低，不支持微信JS接口，请升级到最新的微信版本！");
          return false;
        }
      },
    });
    wx.openLocation({
      name: storeName, // 位置名
      latitude: Number(shopLat), // 纬度，浮点数，范围为90 ~ -90
      longitude: Number(shopLon), // 经度，浮点数，范围为180 ~ -180
      address: shopAddress, // 地址详情说明
      scale: 12, // 地图缩放级别,整形值,范围从1~28。默认为最大
      infoUrl: "", // 在查看位置界面底部显示的超链接,可点击跳转
      success: function (res) {},
      fail: function (err) {
        console.log(
          "%c err ",
          "background-image:color:transparent;color:yellow;font-size:2em"
        );
        console.log(err);
        Toast(err);
      },
    });
  });
}

/**
 * @params {number,string} phone 手机号码， 可以为数字或字符串，允许有空格。
 * @return {boolean} 如果是电话号码,返回true，否则false
 * @example  以下情况都返回true
 * isValidPhone('18311056454');
 * isValidPhone(' 18311056454');
 * isValidPhone(' 18311056454 ');
 * isValidPhone( 18311056454 );
 */
export function isValidPhone(phone) {
  const phoneReg = /^1[3456789]\d{9}$/;
  // 将参数先转变成字符串再去除其中的空格后去匹配正则
  if (phoneReg.test(phone.toString().replace(/\s+/g, ""))) {
    return true;
  }
  return false;
}

export function test2(_this) {}



export async function wechatPay(sequenceId, money, other = {},failCallBack) {
  // other中字段解释如下
  // payAfterUrl:'',//微信原生支付成功后返回的页面
  // sqbAfterUrl:''//收钱吧支付成功后返回的页面
  let params = {
    OutTradeNo: sequenceId,
    AppType: 0,
    ...other
  };
  // if (other.sqbAfterUrl) {
  //   params.ReturnUri = location.href.split("#")[0] + "#/" + other.sqbAfterUrl;
  // }
  handleLocalStorage.set("orderId", other.orderId);
  let res = await $http(
    "wechath5/zh-cn/v1/wechat/pay/aggregate",
    params,
    "post"
  );
  if (res.IsCheckoutSuccess) {
     router.replace({ name: other.payAfterUrl });
  } else if (res.wappay_url) {
      window.location.href = res.wappay_url;
  }  else if (!res.paySign) {
     wx.showToast({title:res.message,icon:'none'})
	} else {
   
    // return new Promise((resolve, reject) => {
    getBrandWCPayRequest(res, (sucRes) => {
      if (other.payAfterUrl) {
        //支付成功跳转对应页面
        router.replace({
          name: other.payAfterUrl,
        });
      } else if (other.orderId) {
        router.push({
          path: `/consumecode-detail/${other.orderId}`,
        });
      } else {
        return Promise.resolve();
      }
    });
    return res;
  }


  // if(!other.payType||other.payType=='1'){
  //     params.Body=other.msg
  //     res = await $http('wechath5/zh-cn/v1/wechat/unifiedorder', params, 'post')
  // }else if(other.payType=='3'){//随行付
  //     params.SaasVpnCode=other.vpnCode
  //     res = await $http('wechath5/zh-cn/v1/sxf/pay', params, 'post')
  // }else if(other.payType=='2'){//收钱吧
  //     params.Subject=``
  //     params.Payway=3
  //     params.ReturnUri=location.href.split('#')[0] + '#/'+other.sqbAfterUrl
  //     res = await sqbWxPay(params)
  //     if (res) {
  //         // 支付跳转链接
  //         _paySuccessJump(res);
  //     }
  //     return;
  // }
}

function _paySuccessJump(resParams) {
  //   if (this.isWeChatClient) {
  location.href = resParams;
  //   } else if (resParams.wap_pay_request.h5_pay_redirect_url) {
  //     location.href = `${
  //       resParams.wap_pay_request.h5_pay_redirect_url
  //     }&redirect_url=${encodeURIComponent(this.globalReturnUrl)}`;
  //   } else {
  //   }
}

// export async function wechatPay2(sequenceId, money, msg = '这是默认的body', other = {}) {
//     let params = {
//         OutTradeNo: sequenceId,
//         Fee: money,
//         Body: msg
//     }
//     console.log(`22222<<<  params  >>>22222`);
//     console.log(params);
//     let res = await $http('wechath5/zh-cn/v1/wechat/unifiedorder', params, 'post')
//     console.log(`%c 支付返回数据res` + '', "background-image:color:transparent;color:blue;font-size:2em");
//     console.log(res);
//     // return new Promise((resolve, reject) => {
//     console.log(`22222333<<<  resolve  >>>22222`);
//     getBrandWCPayRequest(wxPayRes, (sucRes) => {
//         location.href = location.href.split('#')[0] + '#/consumecode-detail/' + this.orderId;
//         this.$router.push({
//             path: `/consumecode-detail/${this.orderId}`
//         })
//     })
//     return res
// }

/**
 * 字符串时间转为时间戳
 * @example '2021-12-03 14:47:08' => 1638514028000
 * @param {*} str
 * @returns
 */
export function strToTime(str) {
  let newStr = str.replace(/-/g, "/");
  let res = new Date(newStr).getTime();
  return res;
}
export async function verifyWechatMember(callback) {
  const vpnId = store.state.vpnId;
  getUserCardInfo({ vpnId }).then((res) => {
    if (res.Code) {
      const nowRouteData = router.currentRoute;
      handleLocalStorage.set("registerAfterPage", {
        name: nowRouteData.name,
        query: nowRouteData.query,
        params: nowRouteData.params,
      });
      Toast("该操作需要注册会员，自动为您跳转至注册页面");
      setTimeout(() => {
        router.push({ name: "ValidMember" });
      }, 800);
      return;
    }
    if (res.Token) {
      setToken(res.Token);
    }
    console.log(res);
    handleLocalStorage.set("memberInfo", {
      MemberName: res.MemberName,
      MobilePhone: res.MobilePhone,
    });
    if (callback) callback();
  });
}

// 验证某一场景是否需要强制注册微会员
// type: 场景值
// 1 :扫码取号  2:扫码点餐  3:餐饮排号  4:入场排号  5:自助结账  6:微信商城
export async function verifyNeedWechatMember(type, callback) {
  const vpnId = store.state.vpnId;
  checkIsNeedRegisterWechatMember({ VpnId: vpnId, SceneId: type }).then(
    (res) => {
      //进入则表示不需要进行注册微会员操作,直接进行下一步
      if (callback) callback();
    }
  );
}
